// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  renditionId: __t.u64(),
  minX: __t.f64(),
  minY: __t.f64(),
  minZ: __t.f64(),
  maxX: __t.f64(),
  maxY: __t.f64(),
  maxZ: __t.f64(),
};
